import { useHistory, useParams } from 'react-router';
import {
  StyledFooter,
  StyledHeader,
  StyledMonitoringRulesForm
} from './MonitoringRulesForm.style';
import useAutoRepoDiscovery from '../useAutoRepoDiscovery';
import { useSelector } from 'react-redux';
import { sensorAuthorizationsByIdSelector } from 'state/selectors/sensors-authorizations';
import Icon from 'components/base/Icon';
import useFormState from './useFormState/useFormState';
import useFormSaveHandler from './useFormSaveHandler';
import SwitchWrapper from './form-components/SwitchWrapper';
import InputRegex from './form-components/InputRegex';
import VisibilitySelector from './form-components/VisibilitySelector/VisibilitySelector';
import { LBButton } from '@linearb/buzz';
import OrgDetectionStrategy from './OrgDetectionStrategy';

const MonitoringRulesForm = () => {
  const history = useHistory();
  const { integrationId } = useParams();
  const sensorAutorizationsById = useSelector(sensorAuthorizationsByIdSelector);
  const autoRepoDiscovery = useAutoRepoDiscovery();
  const integration = sensorAutorizationsById[integrationId];
  const integrationDiscoverySetting =
    autoRepoDiscovery.getSettingByIntegrationId(integrationId);

  const formState = useFormState(integrationDiscoverySetting);
  const formSaveHandler = useFormSaveHandler({
    formState,
    integration,
    integrationDiscoverySetting
  });

  const onClose = () => history.goBack();
  const isInitializing = autoRepoDiscovery.isLoading || !integration;

  if (isInitializing) return null;

  return (
    <StyledMonitoringRulesForm>
      <StyledHeader>
        Monitoring Rules Form - {integration.name}
        <Icon name='Close' size='medium' onClick={onClose} />
      </StyledHeader>
      <InputRegex
        inputType={'include-repo'}
        value={formState.inclusionRegex}
        onChange={text => formState.setInclusionRegex(text)}
        title={
          <>
            Define a rule to <b>include</b> repositories as they are discovered
          </>
        }
      />

      <InputRegex
        inputType={'exclude-repo'}
        value={formState.exclusionRegex}
        onChange={text => formState.setExclusionRegex(text)}
        title={
          <>
            Define a rule to <b>exclude</b> repositories as they are discovered
          </>
        }
      />

      <VisibilitySelector
        onChange={formState.onChangeVisibility}
        selectedValues={formState.visibility}
      />

      <OrgDetectionStrategy integration={integration} formState={formState} />

      <StyledFooter>
        <SwitchWrapper
          title='Auto monitored'
          isChecked={formState.isActive}
          onToggle={formState.toggleIsActive}
        />
        <LBButton
          onClick={async () => {
            if (await formSaveHandler.onSave()) {
              onClose();
            }
          }}
          disabled={formSaveHandler.isLoading}
        >
          Save & Close
        </LBButton>
      </StyledFooter>
    </StyledMonitoringRulesForm>
  );
};

export default MonitoringRulesForm;
